/**
 * Svelte action that calls a callback when the Escape key is pressed
 * @param _node - The element (not used, but required for Svelte actions)
 * @param callback - Function to call when Escape is pressed
 * @returns Cleanup function with update method for callback changes
 */
export function escapeKey(
  _node: HTMLElement,
  callback: () => void
): { destroy: () => void; update: (newCallback: () => void) => void } {
  let currentCallback = callback

  function handleKeydown(event: KeyboardEvent) {
    if (event.key === 'Escape') {
      event.preventDefault()
      currentCallback()
    }
  }

  document.addEventListener('keydown', handleKeydown)

  return {
    update(newCallback: () => void) {
      currentCallback = newCallback
    },
    destroy() {
      document.removeEventListener('keydown', handleKeydown)
    },
  }
}
